module.exports = __webpack_public_path__ + "img/biominder-timeline.8f39c601.png";